export function formatDate(isoDate: string, locale = 'fr-FR'): string {
  return new Intl.DateTimeFormat(locale, { dateStyle: 'long' }).format(new Date(isoDate));
}
